import PreLoader from "component/Loader/PreLoader";
import React, { useMemo, useState, Fragment } from "react";
import { useDispatch } from "react-redux";
import { getUserData } from "store/actions";
// import './helpers/AuthType/fakeBackend'; // for mock server using in chatgpt
// import fakeBackend from "./helpers/AuthType/fakeBackend"
// fakeBackend()

function DataWrapper(props) {
  const dispatch = useDispatch();

  const [isAppLoaded, setIsAppLoaded] = useState(false);

  useMemo(async () => {
    setIsAppLoaded(false);
    function checkCookies() {
      return new Promise((resolve, reject) => {
        if (localStorage.getItem("authUser")) {
          dispatch(
            getUserData(
              {},
              () => resolve(true),
              () => reject(false)
            )
          );
        } else {
          reject(false);
        }
      });
    }

    await checkCookies()
      .then(res => {
        return res;
      })
      .catch(err => {
        return err;
      })
      .finally(() => setIsAppLoaded(true));
  }, []);

  return <Fragment>{isAppLoaded ? props.children : <PreLoader />}</Fragment>;
}

export default DataWrapper;
